import { Switch } from "@mui/material";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import ProgressBar from 'react-bootstrap/ProgressBar';
// ------------------
import { HiMiniExclamationTriangle } from "react-icons/hi2";
import { FaArrowRotateLeft, FaCircleInfo } from "react-icons/fa6";
import { BsFillQuestionCircleFill } from "react-icons/bs";
import { PiPercent } from "react-icons/pi";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { TbCurrencyRupee } from "react-icons/tb";
import { FaPlus } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";

import { Save, ArrowRotateLeft, ChartBar } from "../../../../../../../components/icons/Icons"
import TdsDialoge from '../../../../../../../components/Dialog/tdsDialoge';



const LateSubmissionPenaltySettings = ({ genaralState, handleSwitchChange, handleInputChange, toggleValue }) => {
  const [penaltyActive, setPenaltyActive] = useState(true);
  const [autoDeduct, setAutoDeduct] = useState(false);
  const [isImpact, setIsImpact] = useState(false);
  const [quickPresets, setQuickPresets] = useState("3 days")
  const now = 33.33


  const closeImpactDialog = () => {
    setIsImpact(false)
  }

  const submitImpactForm = () => {

  }


  return (
    <div className="late-penalty-settings mb-4">
      <div className="section-header mb-4">
        <h3 className="text-purple font-weight-200"><HiMiniExclamationTriangle /> Late Submission Penalty Settings</h3>
        <span className="color-gray font-14 font-weight-200">Configure penalty rules for late submissions</span>
      </div>

      {/* Section 1 - Rule Definition */}
      <div className="bg-semi-gray border-semi-gray p-4 border-radius-8px mb-4">
        <div className="d-flex align-items-center gap-2 color-white mb-3"><div className="text-purple padding-5-purple">1</div> Rule Definition</div>
        <Row>
          <Col sm="6">
            <div className="semi-card mb-4">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <div>
                  <h3 className="color-white font-weight-200">Activate Late Submission Penalty</h3>
                  <span className="color-gray font-14 font-weight-200">Enable penalty enforcement for overdue submissions</span>
                </div>
                <Switch name="activateLateSubmissionPenalty" checked={genaralState.activateLateSubmissionPenalty === "1"} onChange={handleSwitchChange} />
              </div>
            </div>
            {/* ---------------------- */}
            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 mb-3">Deadline Type &nbsp; <BsFillQuestionCircleFill /></h3>
              <Form.Select name="deadLineType" value={genaralState.deadLineType} onChange={handleInputChange} className="universal-input" style={
                { width: "100%" }
              }>
                <option value={""}>Select</option>
                <option value={"Form 12BB Declaration Deadline"}>Form 12BB Declaration Deadline</option>
              </Form.Select>

              {/* <Form.Control className="universal-input border-radius-8px" placeholder="Deadline type" name="deadLineType" value={genaralState.deadLineType} onChange={handleInputChange} /> */}
            </div>

            {/* ---------------------- */}
            <div className="semi-card">
              <h3 className="color-white font-weight-200 mb-3">Grace Period &nbsp; <BsFillQuestionCircleFill /></h3>
              <div className="d-flex align-items-center gap-2 mb-3 color-gray">
                <span>Allow</span> <Form.Control name="lateSubmissionGracePeriod" value={genaralState.lateSubmissionGracePeriod} onChange={handleInputChange} className="universal-input" placeholder="7" style={{ width: "70px" }} /> <span>days after declared deadline</span>
              </div>
              <div className="d-flex align-items-center gap-2 mb-3 color-gray">
                <h3 className="font-weight-200 font-14 color-gray" >Penalty Start Date:</h3> <h5 className="font-weight-200 font-14 color-white">January 8, 2024</h5>
              </div>
            </div>
          </Col>
          {/* ------------------ */}
          <Col sm="6">
            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 d-flex align-items-center gap-2 mb-3">Calculation Method <BsFillQuestionCircleFill /> </h3>

              <Form.Group>
                <Form.Check
                  onChange={handleInputChange}
                  name="calculationMethod"
                  checked={genaralState.calculationMethod === "Per Day Delay"}
                  value="Per Day Delay"
                  type="radio"
                  label="Per Day Delay"
                  className="color-white font-weight-200 font-14"
                />

                <Form.Check
                  onChange={handleInputChange}
                  name="calculationMethod"
                  checked={genaralState.calculationMethod === "Per Week Delay"}
                  value="Per Week Delay"
                  type="radio"
                  label="Per Week Delay"
                  className="color-white font-weight-200 font-14"
                />

                <Form.Check
                  onChange={handleInputChange}
                  name="calculationMethod"
                  checked={genaralState.calculationMethod === "Fixed Once (after grace ends)"}
                  value="Fixed Once (after grace ends)"
                  type="radio"
                  label="Fixed Once (after grace ends)"
                  className="color-white font-weight-200 font-14"
                />

                <Form.Check
                  onChange={handleInputChange}
                  name="calculationMethod"
                  checked={genaralState.calculationMethod === "Hybrid (Fixed + Per Day thereafter)"}
                  value="Hybrid (Fixed + Per Day thereafter)"
                  type="radio"
                  label="Hybrid (Fixed + Per Day thereafter)"
                  className="color-white font-weight-200 font-14"
                />
              </Form.Group>

            </div>

            <div className="semi-card">
              <h3 className="color-white font-weight-200 d-flex align-items-center justify-content-center gap-2 mb-3">Timeline Visualization <BsFillQuestionCircleFill /> </h3>
              <ProgressBar style={{ height: "8px" }}>
                <ProgressBar
                  now={now}
                  className="custom-bar-green"
                />
                <ProgressBar
                  now={now}
                  className="custom-bar-yellow"
                />
                <ProgressBar
                  now={now}
                  className="custom-bar-red"
                />
              </ProgressBar>

              <div className="d-flex align-items-center justify-content-between mt-1">
                <span className="color-white">Deadline</span>
                <span className="color-white">Grace Period</span>
                <span className="text-purple">Penalty Active Zone</span>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {/* -------------- */}
      <div className="bg-semi-gray border-semi-gray p-4 border-radius-8px mb-4">
        <div className="d-flex align-items-center gap-2 color-white mb-3"><div className="text-purple padding-5-purple">2</div>Penalty Components</div>
        <Row>
          <Col sm="6">
            {/* ---------------------- */}
            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 mb-3">Penalty Type &nbsp; <BsFillQuestionCircleFill /></h3>
              <Form.Select name="penaltyType" value={genaralState.penaltyType} onChange={handleInputChange} className="universal-input">
                <option value={""}>Select Penalty Type</option>
                <option value={"Monetary Deduction"}>Monetary Deduction</option>
              </Form.Select>
            </div>

            {/* ---------------------- */}
            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 mb-3">Amount / Day or Week &nbsp; <BsFillQuestionCircleFill /></h3>
              <div className="d-flex align-items-center gap-2">
                <TbCurrencyRupee className="text-purple font-20" />
                <Form.Control name="penaltyAmount" value={genaralState.penaltyAmount} onChange={handleInputChange} className="universal-input" placeholder="100" />
              </div>
            </div>

            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 mb-3">Maximum Cap &nbsp; <BsFillQuestionCircleFill /></h3>
              <div className="d-flex align-items-center gap-2">
                <TbCurrencyRupee className="text-purple font-20" />
                <Form.Control name="penaltyMaximumCap" value={genaralState.penaltyMaximumCap} onChange={handleInputChange} className="universal-input" placeholder="2000" />
              </div>
            </div>
          </Col>
          {/* ------------------ */}
          <Col sm="6">
            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 mb-3">Interest Factor (Optional) &nbsp; <BsFillQuestionCircleFill /></h3>
              <div className="d-flex align-items-center gap-2">
                <Form.Control className="universal-input" placeholder="100" /> <PiPercent className="text-purple font-20" />
              </div>
            </div>
            {/* ---------------- */}
            <div className="semi-card mb-4">
              <div className="d-flex align-items-center justify-content-between gap-2">
                <h3 className="color-white font-weight-200 d-flex align-items-center gap-2">Auto Deduct from Payroll  <BsFillQuestionCircleFill /></h3>
                <Switch name="penaltyDetectFromPayroll" checked={genaralState.penaltyDetectFromPayroll === "1"} onChange={handleSwitchChange} />
              </div>
            </div>
            {/* ----------------- */}
            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 mb-3">Notification Action &nbsp; <BsFillQuestionCircleFill /></h3>
              <Form.Select name="penaltyNotificationAction" value={genaralState.penaltyNotificationAction} onChange={handleInputChange} className="universal-input">
                <option value="">Select Notification Action</option>
                <option value={"Both"}>Both</option>
              </Form.Select>
            </div>
          </Col>
        </Row>
      </div>

      {/* -------------- */}
      <div className="bg-semi-gray border-semi-gray p-4 border-radius-8px mb-4">
        <div className="d-flex align-items-center gap-2 color-white mb-3"><div className="text-purple padding-5-purple">3</div>Exemptions & Exceptions</div>
        <Row>
          <Col sm="6">
            {/* ---------------------- */}
            <div className="semi-card mb-4">
              <h3 className="color-white font-weight-200 mb-3">Auto-Exempt Options</h3>
              <Form.Check name="autoExcemptOptions" value="Employees on Leave during submission period" checked={genaralState.autoExcemptOptions.includes("Employees on Leave during submission period")} onChange={() => toggleValue("Employees on Leave during submission period")} label="Employees on Leave during submission period" className="color-white mb-2 font-weight-200" />
              <Form.Check name="autoExcemptOptions" value="New Joiners (joined after FY start)" checked={genaralState.autoExcemptOptions.includes("New Joiners (joined after FY start)")} onChange={() => toggleValue("New Joiners (joined after FY start)")} label="New Joiners (joined after FY start)" className="color-white mb-2 font-weight-200" />
              <Form.Check name="autoExcemptOptions" value="HR-Approved Cases" checked={genaralState.autoExcemptOptions.includes("HR-Approved Cases")} onChange={() => toggleValue("HR-Approved Cases")} label="HR-Approved Cases" className="color-white mb-2 font-weight-200" />
            </div>
          </Col>
          {/* ------------------ */}
          <Col sm="6">
            <div className="semi-card mb-4">
              <div className="d-flex align-items-center justify-content-between gap-2 color-white mb-3">
                <h3 className="color-white font-weight-200">Manual Overrides</h3>
                <button className="universal-btn border-radius-8px"> <FaPlus /> Add Exception</button>
              </div>
              <div className="semi-card mb-4">
                <h3 className="color-gray font-weight-200 font-16 mb-3">Current Exceptions</h3>
                <div className="semi-card mb-4 d-flex align-items-center justify-content-between gap-2 color-white">
                  <div className="">
                    <h3 className="color-white font-weight-200">EMP124 - Suresh Kumar</h3>
                    <h5 className="color-gray font-weight-200">Medical Leave - HR Manager - 22 Dec 2025</h5>
                  </div>
                  <FaTimes className="text-red" />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {/* -------------- */}
      <div className="bg-semi-gray border-semi-gray p-4 border-radius-8px mb-4">
        <div className="d-flex align-items-center gap-2 color-white mb-3"><div className="text-purple padding-5-purple">4</div>Additional Notes & Preview</div>
        <Row>
          <Col sm="12">
            {/* ---------------------- */}
            <div className="mb-4">
              <h3 className="color-white font-weight-200 mb-3">Audit Note</h3>
              <textarea name="auditNote" value={genaralState.auditNote} onChange={handleInputChange} className="universal-input height-100 " style={{ width: "100%", height: "100px" }} placeholder="Describe reason or policy reference for enabling penalties...">
              </textarea>
            </div>
          </Col>
          {/* ------------------ */}
        </Row>

        <div className="d-flex align-items-center justify-content-center gap-2">
          <button
            className="universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2 d-flex align-items-center gap-2"
            onClick={() => setIsImpact(true)}
          >
            <ChartBar /> Preview Impact
          </button>
          <button
            className="universal-purple-btn border-radius-8px d-flex align-items-center justify-content-center gap-2 d-flex align-items-center gap-2">
            <Save /> Save Settings
          </button>
          <button
            className="universal-sec-btn border-radius-8px d-flex align-items-center justify-content-center gap-2 d-flex align-items-center gap-2">
            <ArrowRotateLeft class_name={""} /> Refesh
          </button>
        </div>
      </div>

      <TdsDialoge
        staffId={""}
        isImpact={isImpact}
        closeImpactDialog={closeImpactDialog}
        submitImpactForm={submitImpactForm}
        quickPresets={quickPresets}
        setQuickPresets={setQuickPresets}
      />
    </div>
  );
};

export default LateSubmissionPenaltySettings;
